import * as React  from 'react';
import '../../inCss/Error.css';

export interface ErrorProps {
    errorTitle: string;
    errorMessage: string;
    errorStatus: string;
    clickEvt: () => void;
}

export const ErrorCard: React.StatelessComponent<ErrorProps> = (props) => {

    return (
        <div className="card card-padding">
            <div className="card-body text-center">
                <h5><img id="warning" src="/img/warn.png"/></h5>
                <p className="errorTitle">{props.errorTitle}</p>                      
                {props.errorMessage.split('|').map((item, index) => (                    
                    <p className="card-text text-muted errorMessage" key={index}>
                    {item}
                    <br/>
                    </p>                                
                ))}
                { (props.errorStatus !== 'TDI_LINK_ERROR' 
                    && props.errorStatus !== 'EXCEEDED_REQUEST_ERROR'
                    && props.errorStatus !== 'TDI_RELATIONSHIP_ERROR'
                    && props.errorStatus !== 'ROUTE_ERROR') &&
                    <button id="btn_tryagain" className="button-tryagain" onClick={props.clickEvt}>
                        Try Again
                    </button>
                }
            </div>

        </div>
    );
};

export default ErrorCard;



// WEBPACK FOOTER //
// ./src/components/cards/ErrorCard.tsx